import { render, staticRenderFns } from "./ItemCell.vue?vue&type=template&id=50fd53a3&scoped=true&"
import script from "./ItemCell.vue?vue&type=script&lang=js&"
export * from "./ItemCell.vue?vue&type=script&lang=js&"
import style0 from "./ItemCell.vue?vue&type=style&index=0&id=50fd53a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd53a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50fd53a3')) {
      api.createRecord('50fd53a3', component.options)
    } else {
      api.reload('50fd53a3', component.options)
    }
    module.hot.accept("./ItemCell.vue?vue&type=template&id=50fd53a3&scoped=true&", function () {
      api.rerender('50fd53a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform-items/components/ItemCell.vue"
export default component.exports